// eslint-disable-next-line max-len
import { IAccommodationBlockingDateRange } from '../accommodation-blocking-date-range/accommodation-blocking-date-range';
import { IAccommodationBlockingDirection } from '../accommodation-blocking-direction/accommodation-blocking-direction';
import { IAccommodationBlockingType } from '../accommodation-blocking-type/accommodation-blocking-type';

export const MAX_PUBLICATIONS = 250;
export const MAX_COUNTRIES = 800;
export const MAX_REGIONS = 800;
export const MAX_DESTINATIONS = 800;
export const MAX_ACCOMMODATIONS = 350;
export const MAX_TRANSPORT_HUBS = 1000;
export const MAX_REMARK_LENGTH = 255;
export const MAX_DURATIONS_LENGTH = 100;

export interface IAccommodationBlockingForm {
  publications: string[];
  countries: string[];
  regions: string[];
  destinations: string[];
  accommodations: string[];
  airportsOrBusStops: string[];
  dateRange: IAccommodationBlockingDateRange;
  direction: IAccommodationBlockingDirection;
  blockingType: IAccommodationBlockingType;
  remark: string;
  durations: string;
}

function getTomorrow(): Date {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
}

export function getDefaultAccommodationBlockingForm(): IAccommodationBlockingForm {
  const today = new Date();
  return {
    publications: [],
    countries: [],
    regions: [],
    destinations: [],
    accommodations: [],
    airportsOrBusStops: [],
    dateRange: { dateFrom: today, dateTo: getTomorrow(), openDate: false },
    // eslint-disable-next-line unicorn/no-null
    direction: null,
    blockingType: 'stay',
    remark: '',
    durations: '',
  };
}
